import { Component, OnInit, Input, Inject } from '@angular/core';
import { ClusterOptionsAction } from './cluster-options.interface';
import { Cluster } from '../cluster.interface';
import { AuthService } from '../../../auth/auth.service';
import { ClusterService } from '../cluster.service';
import { AreaService } from '../../area/area.service';
import { ProjectService } from '../../project/project.service';
import { ColorScheme } from '../../../utilities/color/color.interface';
import { ColorService } from '../../../utilities/color/color.service';

@Component({
  selector: 'sg2-cluster-options',
  templateUrl: './cluster-options.component.html',
  styleUrls: ['./cluster-options.component.less']
})
export class ClusterOptionsComponent implements OnInit {

  /** Default options. */
  private readonly OPTIONS_DEFAULT: ClusterOptionsAction['action'][] = ['color', 'delete', 'edit'];

  /** Cluster. */
  @Input() cluster: Cluster;

  /** Disabled state of menu. */
  @Input() disabled: boolean;

  /** Set custom selection of options. */
  @Input() options: string[];

  /** Current color scheme. */
  public colorScheme: ColorScheme;

  /** Binding for legacy Material dialog. */
  private $mdDialog: any;

  /** Binding for AngularJS $scope. */
  private $scope: any;

  /** Configuration. */
  public config: {
    addArea?: boolean;
    color?: boolean;
    delete?: boolean;
    edit?: boolean;
  } = { };

  constructor(
    @Inject('$mdDialog') $mdDialog: any,
    @Inject('$scope') $scope: any,
    private areaService: AreaService,
    public authService: AuthService,
    private clusterService: ClusterService,
    private colorService: ColorService,
    private projectService: ProjectService
  ) {
    this.$mdDialog = $mdDialog;
    this.$scope = $scope;
  }

  ngOnInit() {
    this._setOptions();
    this.colorScheme = this.colorService.getScheme('clusters');
  }

  /**
   * Add new area.
   *
   * @param cluster The parent cluster.
   */
  public addArea(cluster: Cluster): void {
    this.areaService.add(cluster.buildingId, cluster._id, {}, true);
  }

  /**
   * Delete cluster.
   *
   * @param cluster The cluster to delete.
   */
  public delete(cluster: Cluster): void {
    this.clusterService.delete(cluster, true);
  }

  /**
   * Edit cluster.
   *
   * @todo Open create/edit area modal or sidebar.
   *
   * @param cluster The cluster to edit.
   */
  public edit(cluster: Cluster): void {
    this.clusterService.edit(cluster, null, true);
  }

  /**
   * Open color picker.
   *
   * @todo Set picker to correct position.
   * @todo Finish method.
   *
   * @param event Mouse event on menu item click.
   */
  public openColorPicker(event: MouseEvent): void {
    const picker = document.createElement('input');
    picker.setAttribute('type', 'color');
    picker.click();
  }

  /**
   * Set color of the cluster.
   *
   * @param cluster The cluster to set the color for.
   * @param color The color in hex format.
   */
  public setColor(cluster: Cluster, color: string): void {
    this.clusterService.setColor(cluster, color);
  }

  /**
   * Set menu options.
   *
   * A custom selection of options can be added by using the options binding.
   * When no options are given, the default selection is used.
   */
  private _setOptions(): void {
    this.options = this.options || this.OPTIONS_DEFAULT;
    this.options.forEach(o => {
      this.config[o] = true;
    });
  }

}
